export const CLEAR_FILTER = 'CLEAR_FILTER';
export function clearFilter(){
	return function(dispatch){
		dispatch({ type: CLEAR_FILTER });
	}
}

export const ADD_FILTER = 'ADD_FILTER';
export function addFilter(name, value){
	return function(dispatch){
		dispatch({ type: ADD_FILTER, name, value });
	}
}

export const REMOVE_FILTER = 'REMOVE_FILTER';
export function removeFilter(name, value){
	return function(dispatch){
		dispatch({ type: REMOVE_FILTER, name, value });
	}
}

export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export function toggleFilter(name, value){
	return function(dispatch){
		dispatch({ type: TOGGLE_FILTER, name, value });
	}
}

export const SET_FILTER_TEXT = 'SET_FILTER_TEXT';
export function setFilterText(text){
	return function(dispatch){
		dispatch({ type: SET_FILTER_TEXT, text });
	}
}

export const RESET_FILTER = 'RESET_FILTER';
export function resetFilter(){
	return { type: RESET_FILTER }
}

export const SET_PAGE = 'SET_PAGE';
export function setPage(page){
	return { type: SET_PAGE, page }
}

export const SET_FILTER = 'SET_FILTER';
export function setFilter(filter){
	return { type: SET_FILTER, filter }
}



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/blog-grid/actions/filter.js